import { supabase } from "./supabase";

const CHANNEL = "dsc-auth-sync";
const KEY = "dsc-auth-leader";
const TTL = 15000;
const HEARTBEAT = 4000;

const tabId = (() => {
    const existing = sessionStorage.getItem("dsc_tab_id");
    if (existing) return existing;
    const v = `${Date.now()}_${Math.random().toString(16).slice(2)}`;
    sessionStorage.setItem("dsc_tab_id", v);
    return v;
})();

function now() {
    return Date.now();
}

function readLeader() {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

function writeLeader(id) {
    localStorage.setItem(KEY, JSON.stringify({ tabId: id, exp: now() + TTL }));
}

function isLeader() {
    const l = readLeader();
    return l && l.tabId === tabId && l.exp > now();
}

function tryBecomeLeader() {
    const l = readLeader();
    if (!l || l.exp <= now()) {
        writeLeader(tabId);
        return true;
    }
    return l.tabId === tabId;
}

export function startAuthLeader() {
    const bc =
        typeof BroadcastChannel !== "undefined"
            ? new BroadcastChannel(CHANNEL)
            : null;

    const applyRole = () => {
        if (isLeader()) {
            supabase.auth.startAutoRefresh();
        } else {
            supabase.auth.stopAutoRefresh();
        }
    };

    const tick = () => {
        const became = tryBecomeLeader();
        applyRole();
        if (became) writeLeader(tabId);
        bc?.postMessage({ type: "PING", tabId, ts: now() });
    };

    bc?.addEventListener("message", applyRole);
    window.addEventListener("storage", (e) => {
        if (e.key === KEY) applyRole();
    });

    tick();
    setInterval(tick, HEARTBEAT);
}
